<template>
  <PricesContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import PricesContent from "../../components/Prices/PricesContent.vue";

export default defineComponent({
  name: "PricesPage",
  components: {
    PricesContent,
  },
});
</script> 